import * as React from 'react';
import Button from '@mui/joy/Button';
import Divider from '@mui/joy/Divider';
import DialogTitle from '@mui/joy/DialogTitle';
import DialogContent from '@mui/joy/DialogContent';
import DialogActions from '@mui/joy/DialogActions';
import Modal from '@mui/joy/Modal';
import ModalDialog from '@mui/joy/ModalDialog';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';

export default function WarningDialog({
  title = 'Discard Changes',
  content = 'Are you sure you want to discard your changes?',
  confirmText = 'Discard',
  cancelText = 'Cancel',
  onConfirm,
  onCancel = null,
  shouldDisplay = true,
  activateButton = null,
  confirmButtonProps = {},
  cancelButtonProps = {},
  ...restProps
}) {
  const openHandler = () => {
    if(!shouldDisplay) {
      try {
        onConfirm();
      } catch(e) {
          //
      }

      return;
    }

    setOpen(true);
  };
  const [open, setOpen] = React.useState<boolean>(false);
  const Btn = activateButton;
  return (
    <React.Fragment>
      {activateButton !== null && <Btn {...restProps} onClick={openHandler}/>}
      {activateButton === null && (
        <Button
            variant="outlined"
            color="danger"
            endDecorator={<DeleteForeverRoundedIcon />}
            {...restProps}
            onClick={openHandler}
        >
            Discard
        </Button>
      )}
      <Modal
        open={open}
        // onClose={() => setOpen(false)}
      >
        <ModalDialog variant="outlined" role="alertdialog">
          <DialogTitle>
            <WarningRoundedIcon />
            {title}
          </DialogTitle>
          <Divider />
          <DialogContent>
            {content}
          </DialogContent>
          <DialogActions>
            <Button
                variant="solid"
                color="danger"
                onClick={() => {
                    setOpen(false);
                    try {
                        onConfirm();
                    } catch(e) {
                        //
                    }
                }}
                {...confirmButtonProps}
            >
              {confirmText}
            </Button>
            <Button
                variant="plain"
                color="neutral"
                onClick={() => {
                    setOpen(false);
                    try {
                        onCancel();
                    } catch(e) {
                        //
                    }
                }}
                {...cancelButtonProps}
            >
              {cancelText}
            </Button>
          </DialogActions>
        </ModalDialog>
      </Modal>
    </React.Fragment>
  );
}
